export const APPLICATION_LOGS = "applicationLogs"
export const APPLICATION_LOGS_REQUEST_STATUS = "applicationLogsRequestStatus"
